import { styled } from 'linaria/react';
import { strictBreakpoints } from '../../../../../media';

export const StyledDiv = styled.div`
	display: flex;
	flex-direction: row;
	width: max-content;
	column-gap: 24px;
	${strictBreakpoints.onlyMobile} {
		column-gap: 16px;
		padding-bottom: 40px;
	}
`;

export const Wrapper = styled.div`
	display: none;
	${strictBreakpoints.onlyMobile} {
		display: block;
		width: 100vw;
		margin-inline: -16px;
		margin-top: 24px;
		padding-inline: 16px;
		margin-bottom: 0;
		overflow-x: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}
`;
